import createImmutableSelector from 'lib/immutable/selector'
import { ISuccessLayout } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getSuccessLayout = (state: any): ISuccessLayout => state.get('successLayoutReducer')

export const successLayoutSelector = createImmutableSelector(getSuccessLayout, (successLayout) => successLayout)
